import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useCookies } from 'react-cookie'

// core
import { useGlobal } from '_core/hooks/useGlobal'
import { makeFetch } from '_core/utils/makeFetch'
import { encodeKey } from '_core/utils/storage'
import { themeActions, themeSelectors } from '_core/store/Theme'
import { ThemeSwitchView } from './ThemeSwitchView'

const mapState = state => ({
  themes: themeSelectors.getThemeList(state),
  themeId: themeSelectors.getCurrentThemeId(state),
})

const mapDispatch = {
  changeTheme: themeActions.changeTheme,
}

const RawThemeSwitch = props => {
  const {
    className,
    tooltip,
    color,
    inMenu,
    hasSigns,
    themes,
    themeId,
    changeTheme,
  } = props

  const {
    theming: { applyTheme },
    config: { COOKIES_TIME, COOKIES_KEY },
  } = useGlobal()

  const [isLoading, setIsLoading] = useState(false)
  const [, setCookie] = useCookies([encodeKey(COOKIES_KEY.THEME)])

  const onChange = async () => {
    const index = themes.findIndex(theme => theme.id === themeId)
    const newIndex = index < themes.length - 1 ? index + 1 : 0
    const newId = themes[newIndex].id

    setIsLoading(true)

    try {
      applyTheme(await makeFetch({ url: themes[newIndex].path }))

      // Change app theme in store
      changeTheme(newId)

      // Change app theme cookie
      updateCookie(newId)
    } catch (error) {
      process.env.NODE_ENV !== 'production' && console.error(error)
    }

    setIsLoading(false)
  }

  const updateCookie = newId => {
    const stamp = Date.now() + COOKIES_TIME

    setCookie(encodeKey(COOKIES_KEY.THEME), newId, {
      path: '/',
      expires: new Date(stamp),
    })
  }

  return (
    <ThemeSwitchView
      className={className}
      tooltip={tooltip}
      themes={themes}
      color={color}
      themeId={themeId}
      isLoading={isLoading}
      onChange={onChange}
      hasSigns={hasSigns}
      inMenu={inMenu}
    />
  )
}

RawThemeSwitch.defaultProps = {}

RawThemeSwitch.propTypes = {
  // self props
  className: PropTypes.string,
  tooltip: PropTypes.string,
  color: PropTypes.string,
  hasSigns: PropTypes.bool,
  inMenu: PropTypes.bool,

  // `redux-connect` HOC props
  themes: PropTypes.arrayOf(PropTypes.object).isRequired,
  themeId: PropTypes.number.isRequired,
  changeTheme: PropTypes.func.isRequired,
}

export const ThemeSwitch = connect(mapState, mapDispatch)(RawThemeSwitch)
